import Icon from '../components/Icon.vue'

Icon.register({
  stamp: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M32 512H480V448H32V512zM416 256H349.4C333.2 256 320 242.8 320 226.6V217.1C320 189.7 328.9 163.7 341.5 139.4 350.6 121.8 354.4 101 350.5 79 343.7 40.2 312 8.3 273.3 1.5 212.6-9 160 37.3 160 96 160 110.2 163.1 123.5 168.7 135.6 182 164.4 192 194.7 192 226.5V226.6C192 242.8 178.8 256 162.6 256H96C43 256 0 299 0 352V384C0 401.7 14.3 416 32 416H480C497.7 416 512 401.7 512 384V352C512 299 469 256 416 256z'
      }
    ]
  }
})
